module.exports = __webpack_public_path__ + "static/img/loading.984a9e3f.gif";